import { render, staticRenderFns } from "./TermsContent.vue?vue&type=template&id=57e8473c"
import script from "./TermsContent.vue?vue&type=script&lang=js"
export * from "./TermsContent.vue?vue&type=script&lang=js"
import style0 from "./TermsContent.vue?vue&type=style&index=0&id=57e8473c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports